import Vapi from '@borisp/vuex-rest-api'
import { payloadToState, getOptimisticDelete } from 'utils/helpers'
import { VUE_APP_BASE_API_URL } from '@/constants/fileConstants'

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    maturityRatings: [],
    maturityRatingsMetadata: {},
    maturityRating: {},
    maturityRatingMetadata: {}
  }
})
    .get({
        action: 'getMaturityRatings',
        property: 'maturityRatings',
        queryParams: true,
        path: '/maturity-ratings/',
        onSuccess: payloadToState('maturityRatings')
    })
    .post({
        action: 'createMaturityRating',
        property: 'maturityRating',
        path: '/maturity-ratings/',
        onSuccess: payloadToState('maturityRating')
    })
    .get({
        action: 'getMaturityRating',
        property: 'maturityRating',
        path: ({ id }) => `/maturity-ratings/${id}`,
        onSuccess: payloadToState('maturityRating')
    })
    .put({
        action: 'updateMaturityRating',
        property: 'maturityRating',
        path: ({ id }) => `/maturity-ratings/${id}`,
        onSuccess: payloadToState('maturityRating')
    })
    .delete({
        action: 'deleteMaturityRating',
        property: 'maturityRating',
        path: ({ id }) => `/maturity-ratings/${id}`,
        beforeRequest: getOptimisticDelete('maturityRatings'),
        onSuccess: payloadToState('maturityRating')
    })
    .getStore()
